/**
 * Utilitários de telefone/WhatsApp (Brasil), sem dependência externa.
 * - formatPhoneBR: máscara de exibição, (11) 98765-4321
 * - normalizePhoneBR: dígitos com DDI 55 para armazenar e gerar https://wa.me/<n>
 * - isValidPhoneBR: valida celular/fixo nacional
 *
 * Cuidado com a ambiguidade DDI 55 vs DDD 55 (Rio Grande do Sul): só tratamos
 * "55" como DDI quando o total de dígitos passa de 11 (número nacional).
 */

export function onlyDigits(value: string): string {
  return (value || '').replace(/\D/g, '');
}

/** Máscara de exibição enquanto o usuário digita. */
export function formatPhoneBR(value: string): string {
  let d = onlyDigits(value);
  if (d.length > 11 && d.startsWith('55')) d = d.slice(2); // já veio com DDI
  d = d.slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  const ddd = d.slice(0, 2);
  const num = d.slice(2);
  if (num.length <= 4) return `(${ddd}) ${num}`;
  if (num.length <= 8) return `(${ddd}) ${num.slice(0, 4)}-${num.slice(4)}`;
  return `(${ddd}) ${num.slice(0, 5)}-${num.slice(5)}`;
}

/** Dígitos com DDI 55 (ex.: 5511987654321). Vazio se não houver dígitos. */
export function normalizePhoneBR(value: string): string {
  const d = onlyDigits(value);
  if (d.startsWith('55') && d.length >= 12) return d; // já tem DDI
  return d ? '55' + d : '';
}

/** Válido como número nacional (DDI + 10 fixo ou 11 celular). */
export function isValidPhoneBR(value: string): boolean {
  const d = normalizePhoneBR(value);
  return d.length === 12 || d.length === 13;
}
